import React from 'react';
import { DiaryEntry } from './DiaryEntry';
export function DiarySection() {
  return <section className="w-full py-12 px-4" data-id="element-35">
      <div className="max-w-2xl mx-auto space-y-8" data-id="element-36">
        <DiaryEntry index={0} rotation={-1} title="Das Problem" date="Vor 4 Monaten" content={<>
              <p data-id="element-38">
                Theo mag morgens kaum fressen. Geht einmal täglich – manchmal
                gar nicht. Der Stuhl ist hart wie Kieselsteine.
              </p>
              <p data-id="element-39">
                Er wirkt träge, schläft viel, hat keine Lust auf Spielen. Der
                Tierarzt spricht von "verlangsamter Darmpassage". Was bedeutet
                das überhaupt?
              </p>
            </>} data-id="element-37" />

        <DiaryEntry index={1} rotation={1} title="Das Verständnis" date="Vor 3 Monaten" content={<>
              <p data-id="element-41">
                Ich lese: der Darm braucht Ballaststoffe als "Besen". Ohne sie
                bewegt sich der Darminhalt zu langsam.
              </p>
              <p data-id="element-42">
                Gärung, Fäulnis, Giftstoffe werden zu lange aufgenommen. Das
                erklärt Theos Lethargie. Ich suche nach natürlichen
                Ballaststoffquellen.
              </p>
            </>} data-id="element-40" />

        <DiaryEntry index={2} rotation={-0.5} title="Die Lösung" date="Vor 8 Wochen" content={<>
              <p data-id="element-44">
                Ein Futtertopping mit löslichen und unlöslichen Ballaststoffen.
                Johannisbrotmehl, Leinsamen, Topinambur. Ich schleiche es ein.
              </p>
              <p data-id="element-45">
                Nach einer Woche: Theo geht zweimal täglich. Nach zwei Wochen:
                der Stuhl ist weicher, gesünder. Er frisst morgens wieder mit
                Appetit.
              </p>
            </>} data-id="element-43" />

        <DiaryEntry index={3} rotation={0.5} title="Heute" date="Heute" content={<>
              <p data-id="element-47">
                Theo ist ein anderer Hund. Lebhaft. Hungrig. Aktiv. Sein Darm
                arbeitet regelmäßig und ruhig.
              </p>
              <p data-id="element-48">
                Ich hätte nie gedacht dass Ballaststoffe so einen Unterschied
                machen können. 🐾
              </p>
            </>} data-id="element-46" />
      </div>
    </section>;
}